module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f3b12b6d76fdad0f243ca6b4fada53dd.png";